import { AdditionalDetailsFTLUnauthenticated } from "../AdditionalDetailsFTLUnauthenticated";
import { OrderMapViewUnauthenticated } from "../OrderMapViewUnauthenticated";
import { TableStopsUnauthenticated } from "../TableStopsUnauthenticated";
import { AdditionalDetailsLTLUnauthenticated } from "../ltl/AdditionalDetailsLTLUnauthenticated";
import { DataSource, Label, Layout, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrderDetailsUnauthenticated extends Layout {
    labelConsigneeETA: Label;
    labelEtaDateTime: Label;
    labelMapConsigneeETA: Label;
    labelMapEtaDateTime: Label;
    labelRateDetails: Label;
    layoutFTLAddlDetails: AdditionalDetailsFTLUnauthenticated;
    layoutLTLAddlDetails: AdditionalDetailsLTLUnauthenticated;
    layoutOrderMapView: OrderMapViewUnauthenticated;
    layoutStops: TableStopsUnauthenticated;
    panelAddlDetails: Panel;
    panelEta: Panel;
    panelMain2: Panel;
    panelMainStops: Panel;
    panelMapEta: Panel;
    panelMapView: Panel;
    panelRateDetails: Panel;
    panelStops: Panel;
    paneltabMapViewAddlDetails: Panel;
    paneltabStopsAddlDetails: Panel;
    sourceCustomerOrderDetailUnauthenticated: DataSource;
    sourceUnauthOrderStops: DataSource;
    tabMapView: Tab;
    tabStops: Tab;
    tabTracking: Tab;
    tableTracking: Table;
    tabsetOrderDetails: Tabset;
    textboxExciseTaxTotal: Textbox;
    textboxFreightCharge: Textbox;
    textboxOtherChargeTotal: Textbox;
    textboxTotalChargeAndExciseTax: Textbox;
}
